import {Customer} from '../models/customer';
import {Article} from "../models/article";
import {Branch} from "../models/branch";


export class Carrito {
    listadoArticulos: BasketItem[];
    customer: Customer;
    branch: Branch;
    customerDelivery: BasketCustomer;

    constructor() {
        this.listadoArticulos = [];
        this.customer = new Customer();
        this.branch = new Branch();
        this.customerDelivery = new BasketCustomer()
    }
}

export class BasketCustomer {
    id: number;
    city: string;
    name: string;
    lastName: string;
    email: string;
    cellphone: string;
    address: string;
    zipCode: string;
    state: string;

    constructor() {
        this.id = null;
        this.city = null;
        this.name = null;
        this.lastName = null;
        this.email = null;
        this.cellphone = null;
        this.address = null;
        this.zipCode = null;
        this.state = null;
    }
}

export class BasketItem {
    id: number;
    item: Article;
    status: string;
    date: Date;
    quantity: number;
    weight: number;
    unitPrice: number;

    constructor() {
        this.id = null;
        this.item = null;
        this.status = null;
        this.date = null;
        this.quantity = null;
        this.weight = null;
        this.unitPrice = null;
    }
}
